import {toLocalDate} from 'src/utils/date'

export default class StipendPaymentStatus {
  id?: number

  institutionId: number

  month: number

  numericYear: number

  actualStipendPaidDate?: Date | null

  expectedDate?: Date | null

  daysOff?: number | null

  isOnTime?: boolean | null

  constructor(data: any) {
    this.id = data.Id ?? data.id
    this.institutionId = data.InstitutionId ?? data.institutionId
    this.month = data.Month ?? data.month
    this.numericYear = data.NumericYear ?? data.numericYear
    const actual = data.ActualStipendPaidDate ?? data.actualStipendPaidDate
    this.actualStipendPaidDate = actual ? toLocalDate(actual) : null
    const expected = data.ExpectedDate ?? data.expectedDate
    this.expectedDate = expected ? toLocalDate(expected) : null
    this.daysOff = data.DaysOff ?? data.daysOff ?? null
    this.isOnTime = data.IsOnTime ?? data.isOnTime ?? null
  }
}
